import { Box, Spinner } from '@everlywell/ui-kit';
import React from 'react';

interface LoadingStateProps {
  minHeight?: string;
  pt?: string[] | string;
  mb?: string[] | string;
}

/**
 * A standardized loading state component
 */
const LoadingState: React.FC<LoadingStateProps> = ({
  minHeight = '400px',
  pt = ['5rem', '6rem'],
  mb = '5rem',
}) => (
  <Box
    as="section"
    pt={pt}
    mb={mb}
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight={minHeight}
  >
    <Spinner size="xl" color="#28724f" />
  </Box>
);

export default LoadingState;
